import * as THREE from 'three';
import {mergeGeometries} from 'three/addons/utils/BufferGeometryUtils.js';
const surface=(color,metalness=0)=>new THREE.MeshStandardMaterial({color,roughness:.68,metalness});
// A pit straight, not a city street: garage bays on the right, roofed stand on the left.
export function createCircuit(platform,scene){
  const concrete=surface('#b2bac2'),dark=surface('#273a51'),glass=surface('#405a74',.35),steel=surface('#b6c1cc',.55),white=surface('#e8e9e5'),blue=surface('#2952a3'),orange=surface('#d96444');
  const groups=new THREE.Group();scene.add(groups);
  const box=(parent,w,h,d,mat,x,y,z)=>{const m=new THREE.Mesh(new THREE.BoxGeometry(w,h,d),mat);m.position.set(x,y,z);parent.add(m);return m;};
  box(scene,4,.07,3000,surface('#58616c'),8,.01,-1400);box(scene,.08,.02,3000,white,6.3,.055,-1400);
  for(let i=0;i<24;i++){
    const cell=new THREE.Group();cell.position.z=20-i*20;groups.add(cell);
    for(const side of [-1,1]){
      box(cell,.48,1.05,20,concrete,side*6.2,.525,0);
      for(let j=0;j<4;j++)box(cell,.5,.07,5,j%2?orange:white,side*5.13,.05,-7.5+j*5);
      // Safety fence with slanted tops, beyond the concrete barriers.
      for(const z of [-9.5,0,9.5]){box(cell,.05,2.4,.05,steel,side*6.35,1.95,z);const arm=box(cell,.05,.48,.05,steel,side*6.24,3.27,z);arm.rotation.z=side*.4;}
      for(let k=0;k<7;k++)box(cell,.025,.018,20,steel,side*6.35,1.18+k*.29,0);
    }
    // Pit building: individually recessed doors, concrete frames and a glazed upper level.
    box(cell,7,4.3,19.5,white,11,2.15,0);box(cell,7.7,.18,20,steel,10.7,4.4,0);
    box(cell,.08,.18,19.7,blue,7.47,2.75,0);box(cell,.08,.08,19.7,orange,7.45,4,0);
    for(let j=0;j<3;j++){
      const z=-6.4+j*6.4;
      box(cell,.08,2.1,5.1,dark,7.46,1.2,z);box(cell,.10,.7,5.5,glass,7.44,3.45,z);
      box(cell,.5,2.5,.2,concrete,7.5,1.25,z-2.8);
      for(let k=0;k<5;k++)box(cell,.10,.025,5,dark,7.39,.45+k*.33,z);
      box(cell,.9,.5,1.6,j%2?orange:blue,8.4,.3,z+1.4);
    }
    // Grandstand treads and bright seats under one long cantilevered roof.
    for(let row=0;row<6;row++){
      const x=-8.2-row*1.06,y=.42+row*.48;
      box(cell,1.08,.45,19.6,concrete,x,y,0);
      for(let j=0;j<9;j++){
        const z=-8.5+j*2.05,seat=(row+j)%4===0?orange:(row+j)%3===0?white:blue;
        box(cell,.62,.1,.75,seat,x,y+.29,z);box(cell,.09,.48,.75,seat,x-.30,y+.52,z);
      }
    }
    box(cell,8.3,.15,20,white,-10.6,5.5,0);
    for(const z of [-9.5,9.5]){box(cell,.16,5.4,.16,steel,-14.2,2.7,z);box(cell,8.6,.14,.12,steel,-10.6,5.35,z);}
    box(cell,.08,.5,18.5,i%2?white:blue,-6.47,.72,0);
    // Grid box markings replace public-road lane dashes.
    for(const z of [-5,5]){box(cell,1.5,.014,.06,white,-1.7,.04,z);box(cell,.06,.014,1.2,white,-2.42,.04,z+.57);box(cell,1.5,.014,.06,white,1.7,.04,z+3);}
  }
  // Static batch per material: the whole repeating track section scrolls as one unit.
  groups.updateMatrixWorld(true);const batches=new Map();groups.traverse(mesh=>{if(!mesh.isMesh)return;if(!batches.has(mesh.material))batches.set(mesh.material,[]);batches.get(mesh.material).push(mesh.geometry.clone().applyMatrix4(mesh.matrixWorld));mesh.geometry.dispose();});
  scene.remove(groups);const roadside=new THREE.Group();scene.add(roadside);
  for(const [mat,geometries] of batches){roadside.add(new THREE.Mesh(mergeGeometries(geometries),mat));for(const geo of geometries)geo.dispose();}
  const facilities=new THREE.Group();scene.add(facilities);
  const label=(message,width,height)=>{const canvas=platform.createSurface();canvas.width=512;canvas.height=128;const c=canvas.getContext('2d');c.fillStyle='#203b65';c.fillRect(0,0,512,128);c.fillStyle='#eef0e9';c.textAlign='center';c.textBaseline='middle';c.font='bold 52px sans-serif';c.fillText(message,256,64);const texture=new THREE.CanvasTexture(canvas);texture.colorSpace=THREE.SRGBColorSpace;return new THREE.Mesh(new THREE.PlaneGeometry(width,height),new THREE.MeshBasicMaterial({map:texture,toneMapped:false}));};
  for(let i=0;i<4;i++){
    const z=-70-i*120;
    box(facilities,6,10,6,concrete,17,5,z);box(facilities,7,2.2,7,glass,17,10.2,z);box(facilities,8,.3,8,steel,17,11.5,z);
    const pit=label('PIT LANE',5.7,1.4);pit.position.set(11.1,4.5,z+17);facilities.add(pit);
    box(facilities,.18,8,.18,steel,-6.6,4,z+30);box(facilities,.18,8,.18,steel,6.6,4,z+30);box(facilities,13.4,.32,.3,steel,0,7.2,z+30);
    const bridge=label('SHIFT CIRCUIT',10,1.25);bridge.position.set(0,6.5,z+30);facilities.add(bridge);
    for(let k=0;k<5;k++)box(facilities,.4,.4,.15,k===0?orange:dark,-1.2+k*.6,5.55,z+30.1);
  }
  return {roadside,facilities};
}
